import React from 'react';

const LeaderItem = props => {
  const { data, rank, rankColor } = props;
  const scoreAlias = props.scoreAlias || 'Score';

  return (
    <div className="leader-item">
      <div className="leaders-circle leader-item-rank" style={{ background: rankColor }}>
        {rank}
      </div>
      <div style={{ gridArea: '1/2', overflow: 'hidden' }}>
        <div style={{ fontWeight: 'bold' }}>{data.name}</div>
        <span style={{ color: rankColor }}>{data.date}</span>
      </div>
      <div className="leader-item-score" style={{ gridArea: '1/3' }}>
        <div style={{ color: rankColor }}>{scoreAlias}</div>
        <span>{data.score}</span>
      </div>
      <div className="leader-item-score" style={{ gridArea: '1/4' }}>
        <div style={{ color: rankColor }}>Plays</div>
        <span>{data.plays}</span>
      </div>
    </div>
  );
};

export default LeaderItem;
